import {
  SubscriptionName,
  SubscriptionPeriod
} from '@anm/api/modules/subscription';
import { UpgradeSubscriptionDiscount } from '@anm/components/subscription/UpgradeSubscriptionBlock';
import roundPrice from '@anm/helpers/pricing/roundPrice';
import { useEffect, useState } from 'react';

import { getCalculatePrice } from '../helpers';

import useSubscriptionCalculate from './useSubscriptionCalculate';

type UsePredictPriceProps = {
  coupon?: string;
  period?: SubscriptionPeriod;
  subscriptionName?: SubscriptionName;
};

const usePredictPrice = ({
  coupon,
  period,
  subscriptionName
}: UsePredictPriceProps) => {
  const [calculation, isPredictPricePending] = useSubscriptionCalculate(
    coupon,
    subscriptionName
  );
  const [discount, setDiscount] = useState<
    UpgradeSubscriptionDiscount | undefined
  >(undefined);
  const [totalPrice, setTotalPrice] = useState<number>();

  useEffect(() => {
    if (!calculation || !period) return;

    const { prices, startingBalance } = calculation;
    const { price, discount } = getCalculatePrice(prices, period);
    const credit =
      startingBalance < 0 ? roundPrice(-startingBalance) : undefined;
    const totalPrice = price > 0 ? roundPrice(price) : 0;

    setDiscount({ ...discount, credit });
    setTotalPrice(totalPrice);
  }, [period, calculation]);

  return [
    totalPrice,
    isPredictPricePending ? undefined : discount,
    isPredictPricePending
  ] as const;
};

export default usePredictPrice;
